import { motion } from "framer-motion";
import { Users, CalendarDays, Landmark } from "lucide-react";
import { PILLARS } from "@/lib/api";

export const PillarsSection = () => (
  <section className="max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-20" data-testid="pillars-section">
    <div className="grid lg:grid-cols-[1.1fr_1fr] gap-10 lg:gap-16 items-start">
      <div>
        <p className="font-type text-xs uppercase tracking-[0.3em] text-[#5A7355] mb-3">What you're signing up for</p>
        <h2 className="font-type font-bold text-3xl sm:text-4xl text-[#E2705A] leading-tight">
          F.E.R.M
          <span className="block text-[#1B2A41] text-xl sm:text-2xl mt-1">Federal Electoral Representative Member</span>
        </h2>
        <p className="mt-5 text-sm sm:text-base leading-relaxed text-[#1E2830]/85 max-w-prose">
          When you join, you allocate yourself to your federal electorate as a <strong>F.E.R.M</strong>. Every
          electorate forms groups of <strong>10 members (minimum goal)</strong>. Once a group is full, the next group opens, so
          nobody is turned away.
        </p>
        <ul className="mt-6 space-y-3 text-sm sm:text-base">
          {[
            [Users, "10 F.E.R.Ms per group, in all 150 federal electorates."],
            [CalendarDays, "Groups grow into working bodies that meet once a month."],
            [Landmark, "Discuss policy and drive R.O.A.N pillar implementation locally."],
          ].map(([Icon, text]) => (
            <li key={text} className="flex gap-3 items-start">
              <span className="mt-0.5 w-8 h-8 rounded-full bg-[#E5EDE3] text-[#5A7355] flex items-center justify-center flex-shrink-0">
                <Icon className="w-4 h-4" />
              </span>
              <span className="text-[#1E2830]/85">{text}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="bg-[#E5EDE3] rounded-2xl p-6 sm:p-8 border border-[#8FA58A]/40 relative overflow-hidden">
        <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-[#8FA58A]/20" />
        <h3 className="font-type font-bold text-xl sm:text-2xl text-[#1B2A41] mb-5 relative">The 9 Pillars</h3>
        <ol className="space-y-2.5 relative" data-testid="pillars-list">
          {PILLARS.map((p, i) => (
            <motion.li
              key={p}
              initial={{ opacity: 0, x: 16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="flex items-baseline gap-3 text-[#1B2A41] font-semibold text-base sm:text-lg"
            >
              <span className="font-type text-[#E2705A] w-6 text-right">{i + 1}</span>
              {p}
            </motion.li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
